import { MessageCircle } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { getChatUnreadCount } from '../lib/chat-api';
import { useTenantConfig } from '../storefront/lib/hooks';

/**
 * Chat (M-chat) bell. Polls the unread-conversation count every 60s + on focus
 * (the slow global poll — the open thread polls fast on its own page). Links
 * straight to the /messages inbox. Hidden entirely when messaging is disabled
 * tenant-wide.
 */
export function MessagesBell() {
  const cfg = useTenantConfig();
  const enabled = cfg.data?.messagingEnabled ?? false;

  const unreadQ = useQuery({
    queryKey: ['chat', 'unread-count'],
    queryFn: getChatUnreadCount,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    enabled,
  });

  if (!enabled) return null;
  const unread = unreadQ.data?.count ?? 0;

  return (
    <Link
      to="/messages"
      aria-label={unread > 0 ? `Messages, ${unread} unread` : 'Messages'}
      className="relative flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <MessageCircle className="h-4 w-4" />
      {unread > 0 && (
        <span className="absolute right-1 top-1 inline-flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium tabular-nums leading-none text-primary-foreground">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </Link>
  );
}
